import { connect } from 'react-redux';
import Vendas from './vendas';

export default connect()(Vendas);
